import * as tslib_1 from "tslib";
import groupRow from './groupRow.vue';
import groupScroller from './groupScroller.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
let SpellGroup = class SpellGroup extends Vue {
    constructor() {
        super(...arguments);
        this.organizerNum = 0;
        this.groupOrder = 0;
        this.joined = false;
        this.organizers = [];
    }
    async created() {
        console.log('this.activity', this.activity);
        // 获取拼团发起者
        const { data } = await this.$axios.get(`/api/goods/shop/market/group/groupHomeOrganizer`, {
            params: { activity_id: this.activity.id, activityId: this.activity.id },
        });
        this.organizerNum = data.organizer_total;
        this.joined = data.verify_result && data.verify_result.joined;
        this.groupOrder = data.verify_result && data.verify_result.group;
        this.organizers = data.organizers;
        this.$emit('updateGroup', {
            joined: this.joined,
        });
    }
    viewMyGroup() {
        this.$router.push({
            path: `/groupView`,
            query: {
                ...this.$route.query,
                orgId: this.groupOrder.group_order_id,
            },
        });
    }
    async viewGroupRule() {
        if (this.activity.rule_pic) {
            return this.$router.push(`/picPage?src=${this.activity.rule_pic}&isApp=${this.isApp}&height=${this.navbarHeight}`);
        }
    }
    groupBuyList() {
        // todo
        this.$router.push(`/groupList?activityId=${this.activity.id}&type=${this.type}`);
    }
};
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "activity", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "type", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "isApp", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "navbarHeight", void 0);
SpellGroup = tslib_1.__decorate([
    Component({
        components: { groupRow, groupScroller },
    })
], SpellGroup);
export default SpellGroup;
